import { useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';

const useDeviceType = () => {
    // Функция для определения начального типа устройства
    const getInitialDeviceType = () => {
        if (typeof window === 'undefined') return 'unknown'; // для SSR
        return window.innerWidth > 480 ? 'desktop' : 'mobile';
    };

    // Устанавливаем начальное состояние на основе текущей ширины окна
    const [device, setDevice] = useState(getInitialDeviceType);

    // Используем useMediaQuery для отслеживания изменений размера окна
    const isDesktop = useMediaQuery({ minWidth: 481 });
    const isMobile = useMediaQuery({ maxWidth: 480 });

    useEffect(() => {
        if (isDesktop) {
            setDevice('desktop');
        } else if (isMobile) {
            setDevice('mobile');
        } else {
            setDevice('unknown');
        }
    }, [isDesktop, isMobile]);

    return device;
};

export default useDeviceType;